import { faExternalLinkAlt, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Spinner } from '@themesberg/react-bootstrap';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { exportAllChargeStatistic } from '../../../../controller/api/statistic/charge';
import { exportChargeStatisticToExcel } from '../../../../helpers/excelExport';

export const TableRow = (props) => {
  const { count, id, logo, total, from, to, phone } = props;

  const [cookies] = useCookies(['lottmekong']);
  const [isExporting, setIsExporting] = useState(false);

  const linkTo = `/statistics/charge-list?bankId="${id}"&from="${from}"&to="${to}"&phone="${phone}"&totalValue="${total}"&count=${count.methodId}`

  const _onExport = useCallback(async () => {
    setIsExporting(true)
    try {
      const isBankRow = !isNaN(id)

      const response = await exportAllChargeStatistic(cookies.lottmekong, {
        from: from,
        to: to,
        phone: phone,
        bankId: isBankRow ? Number(id) : null,
        methodId: isBankRow ? null : id
      })

      if (response && response.data) {
        exportChargeStatisticToExcel(response.data, { from, to, phone })
      }
    } catch (error) {
      console.error('Export failed:', error)
      alert('Xuất Excel thất bại. Vui lòng thử lại!')
    } finally {
      setIsExporting(false)
    }
  }, [cookies.lottmekong, from, to, phone, id])

  return (
    <tr>
      <td className="text-center">
        <Button variant="success" className="m-1" disabled={isExporting} onClick={_onExport}>
          {isExporting ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Đang xuất...
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faFileExcel} className="me-2" />
              Xuất Excel
            </>
          )}
        </Button>
        &nbsp;
        &nbsp;
        <Button>
          <Link
            target={'_blank'}
            style={{ color: '#fff' }}
            to={linkTo}
            key={id}
          >
            {'Xem chi tiết'}
            <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
          </Link>
        </Button>
      </td>
      {!isNaN(id) ?
        <td className='text-center'>
          <img alt='' src={logo} className="img-thumbnail" width={120} height={30}></img>
        </td>
        :
        <td className='text-center'>{id}</td>
      }
      <td className='text-center'>
        {count.methodId}
      </td>
      <td className='text-center text-success'>{new Intl.NumberFormat('vn-VI', {}).format(total) || ""}</td>
    </tr>
  );
};